import React, { useMemo, useState } from 'react'
import { Link } from 'react-router-dom'
import './ToolPage.css'
import './ColorConverter.css'
import { hexToRgb, rgbToHex, rgbToHsl, isValidHex } from './utils/colorConversions'
import { trackEvent } from '../../lib/analytics'
import { useDocumentMeta } from '../../hooks/useDocumentMeta'

const ColorConverter = () => {
  useDocumentMeta({
    title: 'Conversor de Cores Online  HEX, RGB e HSL  jarder.dev',
    description:
      'Converta cores entre HEX, RGB e HSL instantaneamente, com prévia ' +
      'visual. Grátis, direto no navegador, sem cadastro.',
  })

  const [hex, setHex] = useState('#ff7a45')

  const rgb = useMemo(
    () => (isValidHex(hex) ? hexToRgb(hex) : null),
    [hex],
  )
  const hsl = useMemo(() => (rgb ? rgbToHsl(rgb) : null), [rgb])

  const handlePicker = (value) => {
    setHex(value)
    trackEvent('tool_generate', { tool: 'color_converter' })
  }

  const copy = (value) => {
    navigator.clipboard.writeText(value)
    trackEvent('tool_copy', { tool: 'color_converter' })
  }

  return (
    <div className="tool-page">
      <Link to="/ferramentas" className="tool-back-link">
        ← Todas as ferramentas
      </Link>
      <h1>Conversor de Cores</h1>
      <p className="tool-disclaimer">
        Converta entre HEX, RGB e HSL  digite o código ou use o seletor.
      </p>

      <div className="tool-row">
        <div className="tool-field">
          <label htmlFor="hex-input">HEX</label>
          <input
            id="hex-input"
            type="text"
            value={hex}
            onChange={(e) => setHex(e.target.value)}
          />
        </div>
        <div className="tool-field">
          <label htmlFor="color-picker">Seletor</label>
          <input
            id="color-picker"
            type="color"
            value={isValidHex(hex) ? rgbToHex(hexToRgb(hex)) : '#000000'}
            onChange={(e) => handlePicker(e.target.value)}
          />
        </div>
      </div>

      {!rgb && <p className="tool-error">Cor HEX inválida.</p>}

      {rgb && (
        <>
          <div
            className="color-preview"
            style={{ background: rgbToHex(rgb) }}
          />
          <div className="tool-result-card">
            <span className="tool-result-label">HEX</span>
            <span className="tool-result-value">{rgbToHex(rgb)}</span>
            <div className="tool-result-actions">
              <button
                type="button"
                className="tool-button tool-button-secondary"
                onClick={() => copy(rgbToHex(rgb))}
              >
                Copiar
              </button>
            </div>
          </div>
          <div className="tool-result-card">
            <span className="tool-result-label">RGB</span>
            <span className="tool-result-value">
              rgb({rgb.r}, {rgb.g}, {rgb.b})
            </span>
            <div className="tool-result-actions">
              <button
                type="button"
                className="tool-button tool-button-secondary"
                onClick={() => copy(`rgb(${rgb.r}, ${rgb.g}, ${rgb.b})`)}
              >
                Copiar
              </button>
            </div>
          </div>
          <div className="tool-result-card">
            <span className="tool-result-label">HSL</span>
            <span className="tool-result-value">
              hsl({hsl.h}, {hsl.s}%, {hsl.l}%)
            </span>
            <div className="tool-result-actions">
              <button
                type="button"
                className="tool-button tool-button-secondary"
                onClick={() => copy(`hsl(${hsl.h}, ${hsl.s}%, ${hsl.l}%)`)}
              >
                Copiar
              </button>
            </div>
          </div>
        </>
      )}

      <div className="tool-info-section">
        <h2>Quando usar cada formato</h2>
        <p>
          <strong>HEX</strong> (<code>#ff7a45</code>) é o formato mais
          comum em CSS e design, compacto e fácil de colar em qualquer
          lugar. <strong>RGB</strong> expressa a cor pela mistura de
          vermelho, verde e azul (0255), útil quando você precisa
          ajustar canais individualmente ou aplicar transparência com{' '}
          <code>rgba()</code>. <strong>HSL</strong> descreve a cor por
          matiz, saturação e luminosidade  mais intuitivo para criar
          variações mais claras, escuras ou dessaturadas da mesma cor.
        </p>
      </div>
    </div>
  )
}

export default ColorConverter
